/* eslint-disable react/prop-types */
import React from 'react';

import Forms from '.';

const RadioGroup = ({
    disabled,
    label,
    labelIsHidden,
    name,
    onChange,
    options,
    readonly,
    value
}) => {
    if (!options || !options.length) {
        return null;
    }

    return (
        <Forms.FormGroup
            htmlFor={options[0].id.toString()}
            label={label}
            labelIsHidden={labelIsHidden}
        >
            {options.map(item => {
                return (
                    <div className="radiobutton-wrapper" key={item.id}>
                        <input
                            checked={
                                value && value === item.value
                                    ? true
                                    : item.checked
                            }
                            className="radio__input"
                            disabled={readonly || disabled || item.disabled}
                            id={item.id.toString()}
                            name={name}
                            onChange={onChange}
                            type="radio"
                            value={item.value}
                        />
                        <label
                            className="radio__label"
                            htmlFor={item.id.toString()}
                        >
                            {item.label}
                        </label>
                    </div>
                );
            })}
        </Forms.FormGroup>
    );
};

export default RadioGroup;
